/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { FC, ReactElement, useEffect, useState } from 'react'
import { TFunction } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useAppSelector } from '../../../store'
import { CartItem, Settings } from '../../../types'
import { getAmountWithCurrency } from '../../../utils'
import CartItemCard from '../cartItemCard'
import './index.css'

type CartDrawerProps = {
  t: TFunction<'translation', undefined>
  closeDrawer: () => void
  settings: Settings
}

const CartDrawer: FC<CartDrawerProps> = ({ t, closeDrawer, settings }): ReactElement => {
  const { cartItems } = useAppSelector((state) => state.cartReducer)
  const [subTotal, setSubTotal] = useState<number>(0)
  useEffect(() => {
    const newTotalPrice = cartItems.reduce((acc, cur) => {
      const price = cur.variant ? cur.variant.pricing.price * cur.quantity : 0
      return acc + price
    }, 0)
    setSubTotal(newTotalPrice)
  }, [cartItems])

  return (
    <div className="cart-drawer">
      <div className="cart-drawer-header">
        <button onClick={closeDrawer} aria-label={t('Cart_CloseCartDrawer')}>
          <i className="feather-chevron-right cart-drawer-header-icon"></i>
        </button>
        <h1 className="roman">{t('Common_cart').toUpperCase()}</h1>
      </div>
      <div className="cart-drawer-list blue-scroll-bar">
        {cartItems.length ? (
          cartItems.map((item: CartItem, index: number) => (
            <CartItemCard t={t} cartItem={item} key={item.cartItemApiInfo.productVariantId + index} />
          ))
        ) : (
          <div className="cart-list-empty">
            <i className="feather-shopping-cart cart-list-empty-icon"></i>
            <p className="cart-list-empty-text">{t('Cart_yourCartIsEmpty')}</p>
          </div>
        )}
      </div>
      <div className="cart-drawer-summary">
        <div className="cart-drawer-summary-info">
          <div className="cart-drawer-summary-info-total" tabIndex={0}>
            <p className="heavy">{t('Cart_subTotal')}</p>
            <p className="heavy" style={{ display: 'flex', alignItems: 'flex-start' }}>
              <span
                className="cart-item-middle-info-current-price-bg"
                aria-label={getAmountWithCurrency(settings.locale.language, settings.currency.currencyAbbreviation, subTotal)}
              >
                {getAmountWithCurrency(settings.locale.language, settings.currency.currencyAbbreviation, subTotal)}
              </span>
            </p>
          </div>
          <p tabIndex={0}>{t('Cart_taxDisclaimer')}</p>
        </div>
        <Link to="/cart">
          <button className="cart-drawer-summary-view-cart-button light" aria-label="View Cart Page">
            {t('Cart_viewCart')}
          </button>
        </Link>
      </div>
    </div>
  )
}

export default CartDrawer
